import { APP_SECRET } from "utils/Constants";
import jwt from "jsonwebtoken";
import { UserData } from "types/users";

export const decodeToken = (token: string): Promise<UserData> => {
  return new Promise((resolve, reject) => {
    jwt.verify(
      token,
      `${APP_SECRET}`,
      (err: jwt.VerifyErrors | null, decoded?: Object) => {
        if (err) {
          reject(err); // Handle error appropriately
        } else {
          // Token is valid, and 'decoded' contains the decoded data
          //   console.log("decode =>", decoded);
          const decodedData = decoded as UserData;
          resolve(decodedData);
        }
      }
    );
  });
};
